import _toConsumableArray from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { assignNativeAudioNodeOptions } from '../helpers/assign-native-audio-node-options';
import { interceptConnections } from '../helpers/intercept-connections';
export var createNativePannerNodeFakerFactory = function createNativePannerNodeFakerFactory(connectNativeAudioNodeToNativeAudioNode, createInvalidStateError, createNativeChannelMergerNode, createNativeGainNode, createNativeScriptProcessorNode, createNativeWaveShaperNode, createNotSupportedError, disconnectNativeAudioNodeFromNativeAudioNode, monitorConnections) {
  return function (nativeContext, _ref) {
    var coneInnerAngle = _ref.coneInnerAngle,
        coneOuterAngle = _ref.coneOuterAngle,
        coneOuterGain = _ref.coneOuterGain,
        distanceModel = _ref.distanceModel,
        maxDistance = _ref.maxDistance,
        orientationX = _ref.orientationX,
        orientationY = _ref.orientationY,
        orientationZ = _ref.orientationZ,
        panningModel = _ref.panningModel,
        positionX = _ref.positionX,
        positionY = _ref.positionY,
        positionZ = _ref.positionZ,
        refDistance = _ref.refDistance,
        rolloffFactor = _ref.rolloffFactor,
        audioNodeOptions = _objectWithoutProperties(_ref, ["coneInnerAngle", "coneOuterAngle", "coneOuterGain", "distanceModel", "maxDistance", "orientationX", "orientationY", "orientationZ", "panningModel", "positionX", "positionY", "positionZ", "refDistance", "rolloffFactor"]);

    var pannerNode = nativeContext.createPanner(); // Bug #125: Safari does not throw an error yet.

    if (audioNodeOptions.channelCount > 2) {
      throw createNotSupportedError();
    } // Bug #126: Safari does not throw an error yet.


    if (audioNodeOptions.channelCountMode === 'max') {
      throw createNotSupportedError();
    }

    assignNativeAudioNodeOptions(pannerNode, audioNodeOptions);
    var SINGLE_CHANNEL_OPTIONS = {
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete'
    };
    var channelMergerNode = createNativeChannelMergerNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      channelInterpretation: 'speakers',
      numberOfInputs: 6
    }));
    var inputGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, audioNodeOptions), {}, {
      gain: 1
    }));
    var orientationXGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      gain: 1
    }));
    var orientationYGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      gain: 0
    }));
    var orientationZGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      gain: 0
    }));
    var positionXGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      gain: 0
    }));
    var positionYGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      gain: 0
    }));
    var positionZGainNode = createNativeGainNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      gain: 0
    }));
    var scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 6, 1);
    var waveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread(_objectSpread({}, SINGLE_CHANNEL_OPTIONS), {}, {
      curve: new Float32Array([1, 1]),
      oversample: 'none'
    }));
    var lastOrientation = [orientationX, orientationY, orientationZ];
    var lastPosition = [positionX, positionY, positionZ]; // tslint:disable-next-line:deprecation

    scriptProcessorNode.onaudioprocess = function (_ref2) {
      var inputBuffer = _ref2.inputBuffer;
      var orientation = [inputBuffer.getChannelData(0)[0], inputBuffer.getChannelData(1)[0], inputBuffer.getChannelData(2)[0]];

      if (orientation.some(function (value, index) {
        return value !== lastOrientation[index];
      })) {
        pannerNode.setOrientation.apply(pannerNode, orientation); // tslint:disable-line:deprecation

        lastOrientation = orientation;
      }

      var positon = [inputBuffer.getChannelData(3)[0], inputBuffer.getChannelData(4)[0], inputBuffer.getChannelData(5)[0]];

      if (positon.some(function (value, index) {
        return value !== lastPosition[index];
      })) {
        pannerNode.setPosition.apply(pannerNode, positon); // tslint:disable-line:deprecation

        lastPosition = positon;
      }
    };

    Object.defineProperty(orientationYGainNode.gain, 'defaultValue', {
      get: function get() {
        return 0;
      }
    });
    Object.defineProperty(orientationZGainNode.gain, 'defaultValue', {
      get: function get() {
        return 0;
      }
    });
    Object.defineProperty(positionXGainNode.gain, 'defaultValue', {
      get: function get() {
        return 0;
      }
    });
    Object.defineProperty(positionYGainNode.gain, 'defaultValue', {
      get: function get() {
        return 0;
      }
    });
    Object.defineProperty(positionZGainNode.gain, 'defaultValue', {
      get: function get() {
        return 0;
      }
    });
    var nativePannerNodeFaker = {
      get bufferSize() {
        return undefined;
      },

      get channelCount() {
        return pannerNode.channelCount;
      },

      set channelCount(value) {
        // Bug #125: Safari does not throw an error yet.
        if (value > 2) {
          throw createNotSupportedError();
        }

        inputGainNode.channelCount = value;
        pannerNode.channelCount = value;
      },

      get channelCountMode() {
        return pannerNode.channelCountMode;
      },

      set channelCountMode(value) {
        // Bug #126: Safari does not throw an error yet.
        if (value === 'max') {
          throw createNotSupportedError();
        }

        inputGainNode.channelCountMode = value;
        pannerNode.channelCountMode = value;
      },

      get channelInterpretation() {
        return pannerNode.channelInterpretation;
      },

      set channelInterpretation(value) {
        inputGainNode.channelInterpretation = value;
        pannerNode.channelInterpretation = value;
      },

      get coneInnerAngle() {
        return pannerNode.coneInnerAngle;
      },

      set coneInnerAngle(value) {
        pannerNode.coneInnerAngle = value;
      },

      get coneOuterAngle() {
        return pannerNode.coneOuterAngle;
      },

      set coneOuterAngle(value) {
        pannerNode.coneOuterAngle = value;
      },

      get coneOuterGain() {
        return pannerNode.coneOuterGain;
      },

      set coneOuterGain(value) {
        // Bug #127: Safari does not throw an InvalidStateError yet.
        if (value < 0 || value > 1) {
          throw createInvalidStateError();
        }

        pannerNode.coneOuterGain = value;
      },

      get context() {
        return pannerNode.context;
      },

      get distanceModel() {
        return pannerNode.distanceModel;
      },

      set distanceModel(value) {
        pannerNode.distanceModel = value;
      },

      get inputs() {
        return [inputGainNode];
      },

      get maxDistance() {
        return pannerNode.maxDistance;
      },

      set maxDistance(value) {
        // Bug #128: Safari does not throw an error yet.
        if (value < 0) {
          throw new RangeError();
        }

        pannerNode.maxDistance = value;
      },

      get numberOfInputs() {
        return pannerNode.numberOfInputs;
      },

      get numberOfOutputs() {
        return pannerNode.numberOfOutputs;
      },

      get orientationX() {
        return orientationXGainNode.gain;
      },

      get orientationY() {
        return orientationYGainNode.gain;
      },

      get orientationZ() {
        return orientationZGainNode.gain;
      },

      get panningModel() {
        return pannerNode.panningModel;
      },

      set panningModel(value) {
        pannerNode.panningModel = value;
      },

      get positionX() {
        return positionXGainNode.gain;
      },

      get positionY() {
        return positionYGainNode.gain;
      },

      get positionZ() {
        return positionZGainNode.gain;
      },

      get refDistance() {
        return pannerNode.refDistance;
      },

      set refDistance(value) {
        // Bug #129: Safari does not throw an error yet.
        if (value < 0) {
          throw new RangeError();
        }

        pannerNode.refDistance = value;
      },

      get rolloffFactor() {
        return pannerNode.rolloffFactor;
      },

      set rolloffFactor(value) {
        // Bug #130: Safari does not throw an error yet.
        if (value < 0) {
          throw new RangeError();
        }

        pannerNode.rolloffFactor = value;
      },

      addEventListener: function addEventListener() {
        return inputGainNode.addEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      },
      dispatchEvent: function dispatchEvent() {
        return inputGainNode.dispatchEvent(arguments.length <= 0 ? undefined : arguments[0]);
      },
      removeEventListener: function removeEventListener() {
        return inputGainNode.removeEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      }
    };

    if (coneInnerAngle !== nativePannerNodeFaker.coneInnerAngle) {
      nativePannerNodeFaker.coneInnerAngle = coneInnerAngle;
    }

    if (coneOuterAngle !== nativePannerNodeFaker.coneOuterAngle) {
      nativePannerNodeFaker.coneOuterAngle = coneOuterAngle;
    }

    if (coneOuterGain !== nativePannerNodeFaker.coneOuterGain) {
      nativePannerNodeFaker.coneOuterGain = coneOuterGain;
    }

    if (distanceModel !== nativePannerNodeFaker.distanceModel) {
      nativePannerNodeFaker.distanceModel = distanceModel;
    }

    if (maxDistance !== nativePannerNodeFaker.maxDistance) {
      nativePannerNodeFaker.maxDistance = maxDistance;
    }

    if (orientationX !== nativePannerNodeFaker.orientationX.value) {
      nativePannerNodeFaker.orientationX.value = orientationX;
    }

    if (orientationY !== nativePannerNodeFaker.orientationY.value) {
      nativePannerNodeFaker.orientationY.value = orientationY;
    }

    if (orientationZ !== nativePannerNodeFaker.orientationZ.value) {
      nativePannerNodeFaker.orientationZ.value = orientationZ;
    }

    if (panningModel !== nativePannerNodeFaker.panningModel) {
      nativePannerNodeFaker.panningModel = panningModel;
    }

    if (positionX !== nativePannerNodeFaker.positionX.value) {
      nativePannerNodeFaker.positionX.value = positionX;
    }

    if (positionY !== nativePannerNodeFaker.positionY.value) {
      nativePannerNodeFaker.positionY.value = positionY;
    }

    if (positionZ !== nativePannerNodeFaker.positionZ.value) {
      nativePannerNodeFaker.positionZ.value = positionZ;
    }

    if (refDistance !== nativePannerNodeFaker.refDistance) {
      nativePannerNodeFaker.refDistance = refDistance;
    }

    if (rolloffFactor !== nativePannerNodeFaker.rolloffFactor) {
      nativePannerNodeFaker.rolloffFactor = rolloffFactor;
    }

    if (lastOrientation[0] !== 1 || lastOrientation[1] !== 0 || lastOrientation[2] !== 0) {
      pannerNode.setOrientation.apply(pannerNode, _toConsumableArray(lastOrientation)); // tslint:disable-line:deprecation
    }

    if (lastPosition[0] !== 0 || lastPosition[1] !== 0 || lastPosition[2] !== 0) {
      pannerNode.setPosition.apply(pannerNode, _toConsumableArray(lastPosition)); // tslint:disable-line:deprecation
    }

    var whenConnected = function whenConnected() {
      inputGainNode.connect(pannerNode); // Bug #119: Safari does not fully support the WaveShaperNode.

      connectNativeAudioNodeToNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
      waveShaperNode.connect(orientationXGainNode).connect(channelMergerNode, 0, 0);
      waveShaperNode.connect(orientationYGainNode).connect(channelMergerNode, 0, 1);
      waveShaperNode.connect(orientationZGainNode).connect(channelMergerNode, 0, 2);
      waveShaperNode.connect(positionXGainNode).connect(channelMergerNode, 0, 3);
      waveShaperNode.connect(positionYGainNode).connect(channelMergerNode, 0, 4);
      waveShaperNode.connect(positionZGainNode).connect(channelMergerNode, 0, 5);
      channelMergerNode.connect(scriptProcessorNode).connect(nativeContext.destination);
    };

    var whenDisconnected = function whenDisconnected() {
      inputGainNode.disconnect(pannerNode); // Bug #119: Safari does not fully support the WaveShaperNode.

      disconnectNativeAudioNodeFromNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
      waveShaperNode.disconnect(orientationXGainNode);
      orientationXGainNode.disconnect(channelMergerNode);
      waveShaperNode.disconnect(orientationYGainNode);
      orientationYGainNode.disconnect(channelMergerNode);
      waveShaperNode.disconnect(orientationZGainNode);
      orientationZGainNode.disconnect(channelMergerNode);
      waveShaperNode.disconnect(positionXGainNode);
      positionXGainNode.disconnect(channelMergerNode);
      waveShaperNode.disconnect(positionYGainNode);
      positionYGainNode.disconnect(channelMergerNode);
      waveShaperNode.disconnect(positionZGainNode);
      positionZGainNode.disconnect(channelMergerNode);
      channelMergerNode.disconnect(scriptProcessorNode);
      scriptProcessorNode.disconnect(nativeContext.destination);
    };

    return monitorConnections(interceptConnections(nativePannerNodeFaker, pannerNode), whenConnected, whenDisconnected);
  };
};